import getBlockById from 'services/apiHelpers/getBlockById';
import setBlockProps from 'services/apiHelpers/setBlockProps';
import { setInteractionsLockedData } from 'services/scorm/scormService';
import getStore from 'services/getStore';

const unlockInteraction = (id, length = 0) => {
  // console.log('unlock interaction');

  // return () => {};

  if (window.dev()) {
    return () => {};
  }

  const block = getBlockById(id);

  //

  if (!!!length) {
    // resolve any truthy value
    // was strict equality === 1
    if (block.props!.lockDown) {
      // setInteractionsLockedData(id);
      // setBlockProps(block, { lockDown: 0 });

      getStore().dispatch({
        type: 'UPDATE_INTERACTIONS_LOCKED',
        data: { id },
      });
    }

    return () => {};
  }

  let itemsSeen = [] as any[];

  return entry => {
    // resolve any falsey value
    // was strict equality === 0
    if (!block.props!.lockDown) {
      return;
    }

    itemsSeen = itemsSeen.includes(entry) ? itemsSeen : [...itemsSeen, entry];
    itemsSeen.length === length &&
      setTimeout(() => {
        // setInteractionsLockedData(id);
        // setBlockProps(block, { lockDown: 0 });

        getStore().dispatch({
          type: 'UPDATE_INTERACTIONS_LOCKED',
          data: { id },
        });
      }, 100);

    return itemsSeen;
  };
};

export default unlockInteraction;
export { unlockInteraction };
